module.exports = __webpack_public_path__ + "img/planet-jupiter-internal.655e990b.svg";